import Echart from "echarts-for-react"
import { langStore } from "@/stores/lang-store"
import useIsMobile from "@/hooks/use-is-mobile"
import { weekdayBundle, weekdayKeys } from "./weekday-const"

const WeekdayCompareChart = ({ series }) => {
  const { lang } = langStore()
  const isMobile = useIsMobile()
  const weekLabels = weekdayKeys.map((key) => weekdayBundle.days[key][lang])
  const legendNameMap = {
    my: weekdayBundle.compareLegend.my[lang],
    dong: weekdayBundle.compareLegend.dongAverage[lang],
    apt: weekdayBundle.compareLegend.aptAverage[lang]
  }

  const option = {
    tooltip: {
      trigger: "axis"
    },

    legend: {
      top: 0,
      formatter: (name) => legendNameMap[name] ?? name
    },
    grid: {
      top: isMobile ? "10%" : "25%",
      left: isMobile ? "6%" : "3%",
      right: isMobile ? "8%" : "3%",
      bottom: "3%",
      containLabel: true
    },

    xAxis: isMobile
      ? {
          type: "value"
        }
      : {
          type: "category",
          data: weekLabels,
          axisTick: {
            show: false
          }
        },

    yAxis: isMobile
      ? {
          type: "category",
          data: weekLabels,
          inverse: true,
          axisTick: {
            show: false
          }
        }
      : {
          type: "value",
          splitLine: {
            lineStyle: {
              color: "#F1F5F9"
            }
          }
        },

    series: series.map((s) => ({
      ...s,
      name: legendNameMap[s.id] ?? s.name,
      barMaxWidth: 12,
      emphasis: {
        focus: "series"
      }
    }))
  }

  if (series.length === 0) {
    return <div className="w-full" />
  }

  return <Echart style={{ width: "100%", height: "100%" }} notMerge option={option} />
}

export default WeekdayCompareChart
